// Gouvernance — État du système. T-431 / PN-21 : chaque tuile lit /api/health ;
// aucune tuile verte sans mesure (Policy Engine et Gatekeeper, jamais mesurés ici, sont retirés).
import { useEffect, useState } from "react";
import { Server } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function GouvSystemHealthWidget() {
  const [etat, setEtat] = useState({ chargement: true });

  useEffect(() => {
    let annule = false;
    (async () => {
      try {
        const res = await fetch(`${API}/api/health`, { credentials: "include" });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const sante = await res.json();
        if (!annule) setEtat({ sante });
      } catch (e) {
        if (!annule) setEtat({ injoignable: true });
      }
    })();
    return () => { annule = true; };
  }, []);

  const { sante, injoignable, chargement } = etat;
  const base = sante?.database;
  const tuiles = chargement ? [] : [
    injoignable
      ? { cle: "api", label: "API Backend", sub: "Injoignable", couleur: "red" }
      : { cle: "api", label: "API Backend", sub: "Opérationnel", couleur: "green" },
    injoignable
      ? { cle: "db", label: "Base de données", sub: "Inconnue : l'API ne répond pas", couleur: "amber" }
      : base?.reachable
        ? { cle: "db", label: "Base de données", sub: `Connectée${base.latence_ms != null ? ` · ${base.latence_ms} ms` : ""}`, couleur: "green" }
        : { cle: "db", label: "Base de données", sub: base?.erreur || "Injoignable", couleur: "red" },
  ];

  return (
    <div
      className="p-4 rounded-xl"
      style={{ background: "var(--oh-bg-elevated)", border: "0.5px solid var(--oh-border)" }}
      data-testid="gouv-system-health-widget"
    >
      <h3 className="mb-4 flex items-center gap-2" style={{ color: "var(--oh-text)", fontWeight: 500 }}>
        <Server className="w-5 h-5" style={{ color: "var(--oh-accent-text)" }} />
        État du système
      </h3>
      {chargement ? (
        <p style={{ color: "var(--oh-text-muted)", fontSize: 13 }}>Mesure en cours…</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {tuiles.map((t) => (
            <div
              key={t.cle}
              data-testid={`gouv-sante-${t.cle}`}
              data-etat={t.couleur}
              style={{
                background: `var(--oh-stat-${t.couleur}-bg)`,
                color: `var(--oh-stat-${t.couleur}-text)`,
                border: `0.5px solid var(--oh-stat-${t.couleur}-border)`,
                borderRadius: 8, padding: 12, lineHeight: 1.6,
              }}
            >
              <p style={{ fontWeight: 500 }}>{t.label}</p>
              <p style={{ fontSize: 13 }}>{t.sub}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
